import { render } from "./ClientSelection.vue?vue&type=template&id=eefbe3ca&scoped=true"
import script from "./ClientSelection.vue?vue&type=script&lang=js"
export * from "./ClientSelection.vue?vue&type=script&lang=js"

import "./ClientSelection.vue?vue&type=style&index=0&id=eefbe3ca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eefbe3ca"]])

export default __exports__